module.exports = "/images/7c30ac54aedf1bdadc70beae6189ea38.png";